import React from 'react'
import {Button, Grid} from '@mui/material';

const ButtonGroup = (props) => 
{
    const[state, setState] = React.useState([])     

    const[selectedValue, setSelectedValue] = React.useState("")

    React.useEffect(()=>{       
        addIsSelectedPropToState(props.state)
    },[])

    const addIsSelectedPropToState = (state) => 
    {
        var newState = state.map(obj => {
           obj['isSelected'] = false;    
           if(props.hasOwnProperty('noInitialSelection') === false)
           {
                state[0].isSelected = true;
                setSelectedValue(state[0].value)
                props.sendValue(state[0].value) 
           }           
           return obj
        })
        setState(newState)
    }

    const handleButtonClick = (e) =>
    {
        if (e.currentTarget.value !== selectedValue)
        {
            changeSelectedButton(e.currentTarget.value)
            setSelectedValue(e.currentTarget.value)
            props.sendValue(e.currentTarget.value) 
        }      
    }

    const changeSelectedButton = (newSelectedValue) => 
    {
        if(newSelectedValue !== selectedValue)
        {    
            var newState = state.map(option => {
                if(option.isSelected === true)
                {
                    return {...option, isSelected:false}  
                }
                if(option.value === newSelectedValue)
                {
                    return {...option, isSelected:true}
                }
                
                return option
            }) 
            setState(newState)   
        }
    }

    return(
        <>
            {state.map((option, index) => {
                return(
                    <Grid item key={index}>
                        <Button sx={option.isSelected ? props.selectedButtonStyle : props.defaultButtonStyle} value={option.value} onClick={handleButtonClick} >
                            {option.display}
                        </Button> 
                    </Grid>                                                                                                   
                )                          
            })}
        </>
    )
}
export default ButtonGroup
